/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NoteDto = {
    id?: string;
    referenceId?: string;
    referenceType?: NoteDto.referenceType;
    note?: string;
    createdByUserId?: string;
    createdAt?: string;
};
export namespace NoteDto {
    export enum referenceType {
        DOWN_SAVING = 'DOWN_SAVING',
        DOWN_SAVING_TRANSACTION = 'DOWN_SAVING_TRANSACTION',
        FINANCIER_SHOP_CONTRACT = 'FINANCIER_SHOP_CONTRACT',
        INSTALLMENT_CONTRACT = 'INSTALLMENT_CONTRACT',
        POS = 'POS',
        SHOP_COMMISSION = 'SHOP_COMMISSION',
        SHOP_AGENT_COMMISSION = 'SHOP_AGENT_COMMISSION',
        SLIP_VERIFICATION = 'SLIP_VERIFICATION',
        INSTALLMENT_PLAN_MESSAGE = 'INSTALLMENT_PLAN_MESSAGE',
        SUPPORT_CASE = 'SUPPORT_CASE',
        CLAIM = 'CLAIM',
        SOCIAL_WEB = 'SOCIAL_WEB',
        INSTALLMENT_CLAIM_TRANSACTION = 'INSTALLMENT_CLAIM_TRANSACTION',
        FINANCIER_WITHDRAW_DEPOSIT_HISTORY = 'FINANCIER_WITHDRAW_DEPOSIT_HISTORY',
    }
}

